module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"sv":{"welcome-back":"Välkommen tillbaka","enter-password":"Fyll i ditt lösenord för att fortsätta","forgot-password":"Jag har glömt mitt lösenord","or-use":"Eller använd","wrong-password":"Fel lösenord"},"en":{"welcome-back":"Welcome back","enter-password":"Enter your password to continue","forgot-password":"I forgot my password","or-use":"Or use","wrong-password":"Wrong password"}}')
  delete Component.options._Ctor
}
